import { render, staticRenderFns } from "./OrderGeneralInfo.vue?vue&type=template&id=499dfe0b&"
import script from "./OrderGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./OrderGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports